/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="passTip-wrap" v-show="isShow">
        <div class="sanjiao"></div>
        <div class="text_wrap">
            · 密码长度为6-20位<br>
            · 由字母和数字组成
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            showFlag:{
                type: Boolean,
                default:false,
            }
        },
        computed:{
//            isShow(){
//                return this.showFlag;
//            }
        },
        data(){
            return{
                isShow: this.showFlag
            }
        },
        watch:{
            showFlag(){
                this.isShow = this.showFlag
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .passTip-wrap{
        width:318px;
        height:61px;
        position:relative;
        background: #fff;
        .sanjiao{
            width:17px;
            height:23px;
            position: absolute;
            left:0;
            top:18px;
            z-index:9;
            background: url(../../assets/img/common/sanjiao-left.png) no-repeat center center;
        }
        .text_wrap{
            position: absolute;
            left:12px;
            z-index:3;
            top:0;
            width: 300px;
            height:100%;
            padding:10px;
            font-size: 16px;
            color: $c_b7b;
            line-height: 20px;
            border: 2px solid #E3E3E3;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/user/passTip.vue